import React, { useState, useEffect } from "react";
import ConnexionGroupe from "./ConnexionGroup.js";
import FormulaireGroupe from "./FormulaireGroupe.js";
import { Button, Stack, Paper, BottomNavigation, BottomNavigationAction, Box } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import HomeIcon from "@mui/icons-material/Home";
import { useMediaQuery } from "@mui/material";
import { useGroupe } from "../context/GroupeContext.js";
import { useAdminRole } from "../hooks/useAdminRole.js";
import { useLanguage } from '../context/LanguageContext.js';
import { logDev } from "../utils/logger.js";

const ChoixGroup = () => {
  const [mode, setMode] = useState("home");
  const isMobile = useMediaQuery("(max-width:600px)");
  const { t } = useLanguage();
  const { groupeId } = useGroupe();
  const role = useAdminRole(groupeId);
  const isAdmin = role === "admin";

  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [mainMenuHeight, setMainMenuHeight] = useState(0);

  useEffect(() => {
    const header = document.querySelector('.header');
    const footer = document.querySelector('.footer');
    const menu = document.querySelector('.main-menu');

    const updateHeights = () => {
      if (header) setHeaderHeight(header.offsetHeight);
      if (footer) setFooterHeight(footer.offsetHeight);
      if (menu) setMainMenuHeight(menu.offsetHeight);
    };

    updateHeights();
    window.addEventListener('resize', updateHeights);
    return () => window.removeEventListener('resize', updateHeights);
  }, []);

  const topOffset = headerHeight + (isMobile ? footerHeight : mainMenuHeight);
  const bottomOffset = isMobile ? mainMenuHeight : 0;

  if (mode === "connexion") {
    return <ConnexionGroupe setMode={setMode} />;
  }

  if (mode === "creation") {
    return <FormulaireGroupe setMode={setMode} />;
  }

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          paddingX: 2,
          paddingTop: `${topOffset}px`,
          paddingBottom: `${bottomOffset}px`,
          boxSizing: "border-box",
          backgroundColor: "#f4ece2",
          overflowY: "auto"
        }}
      >
        <Box sx={{ maxWidth: 360, width: "100%", marginBottom: isMobile ? "12px" : "32px", marginTop: isMobile ? 0 : 8 }}>
          <div
            style={{
              backgroundColor: "#2f2f2fff",
              padding: "12px 16px",
              borderRadius: "6px",
              fontSize: "1rem",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
              border: "2px solid #d4af37",
              boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
              backgroundImage: "radial-gradient(circle at top left, rgba(255,255,255,0.05), transparent 70%)"
            }}
          >
            {t('ChoiceAdmin')}
          </div>
        </Box>

        <Stack
          spacing={2}
          direction="column"
          alignItems="center"
          sx={{ marginTop: isMobile ? 0 : 8,
            
           }}
          
        >
          <Button
            variant="outlined"
            color="primary"
            startIcon={<LoginIcon />}
            onClick={() => setMode("connexion")}
            sx={{
              color: "#3399FF",
              borderColor: "#3399FF",
              '&:hover': {
                backgroundColor: "#3399FF",
                color: "#fff",
                transform: "scale(1.05)"
              },
              minWidth: 220,
              fontWeight: "bold",
              fontSize: "1rem",
              transition: "all 0.3s ease",
            }}
          >
            {t('ConnectToAGroup')}
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            startIcon={<GroupAddIcon />}
            onClick={() => setMode("creation")}
            sx={{
              color: "#8C78EB",
              borderColor: "#8C78EB",
              '&:hover': {
                backgroundColor: "#8C78EB",
                color: "#fff",
                transform: "scale(1.05)"
              },
              minWidth: 220,
              fontWeight: "bold",
              fontSize: "1rem",
              transition: "all 0.3s ease",
            }}
          >
            {t('CreateNewGroup')}
          </Button>
        </Stack>
      </Box>

      <Paper
        className="main-menu"
        sx={{
          position: "fixed",
          left: 0,
          right: 0,
          zIndex: 10,
          bottom: isMobile ? 0 : "auto",
          top: isMobile ? "auto" : `${headerHeight}px`
        }}
        elevation={3}
      >
        <BottomNavigation
          showLabels
          value={mode}
          onChange={(event, newValue) => {
            logDev("[ChoixGroup] changement de mode", { ancienMode: mode, nouveauMode: newValue });
            setMode(newValue);
          }}
          sx={{
            backgroundColor: "#e4dcd2",
            color: "white",
            "&.Mui-selected": {
              color: "#3399FF"
            }
          }}
        >
          <BottomNavigationAction label={t('Home')} value="home" icon={<HomeIcon />} />
          <BottomNavigationAction label={t('ConnectToAGroup')} value="connexion" icon={<LoginIcon />} />
          <BottomNavigationAction label={t('CreateNewGroup')} value="creation" icon={<GroupAddIcon />} />
        </BottomNavigation>
      </Paper>
    </>
  );
};

export default ChoixGroup;
